export const USER_LOGIN_REQUEST = "login/USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "login/USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "login/USER_LOGIN_FAILED";
export const USER_CLEAR_DATA = "login/USER_CLEAR_DATA";
export const USER_LOGOUT = "login/USER_LOGOUT";
